/**
 * Дёргает трекинговый пиксель AdFox (показ/видимость) загрузкой изображения.
 *
 * Используется тот же примитив, что и внутри библиотеки adfox (`new Image().src = url`):
 * GET-запрос к пикселю засчитывает событие на стороне AdFox.
 */
export function fireTrackingPixel(url: string | null | undefined): void {
  if (!url || typeof window === 'undefined') {
    return;
  }

  const pixel = new Image();

  pixel.src = url;
}
